import React, { PureComponent, createRef } from 'react';
import Dotdotdot from "react-dotdotdot/src/index";
import common from "../../../utils/common";
import AssetThumbnail from "../../AssetThumbnail/AssetThumbnail";
import ConfigurationHelper from "../../../configuration/ClientConfigurationHelper";
import {Avatar, Box, Button, Link, Skeleton, Typography} from "@mui/material";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import "./swiper.css";

const RoundedPlayIcon = () => <Box position={'absolute'} right={16} bottom={16} bgcolor={'rgba(0,0,0,0.65)'}
                                   borderRadius={'50%'} width={'36px'} height={'36px'} display={'flex'}
                                   justifyContent={'center'} alignItems={'center'}>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8.33301 0.666656C9.43758 0.666656 10.333 1.56209 10.333 2.66666V3.14285L12.7835 2.30269C13.1317 2.18328 13.5109 2.36882 13.6303 2.71711C13.6542 2.7867 13.6663 2.85976 13.6663 2.93332V9.06666C13.6663 9.43485 13.3679 9.73332 12.9997 9.73332C12.9261 9.73332 12.853 9.72115 12.7835 9.69729L10.333 8.85713V9.33332C10.333 10.4379 9.43758 11.3333 8.33301 11.3333H2.33301C1.22844 11.3333 0.333008 10.4379 0.333008 9.33332V2.66666C0.333008 1.56209 1.22844 0.666656 2.33301 0.666656H8.33301ZM8.99967 7.9238V4.07618L8.99967 2.66666C8.99967 2.32477 8.74231 2.04298 8.41076 2.00447L8.33301 1.99999H2.33301C1.99112 1.99999 1.70934 2.25735 1.67083 2.58891L1.66634 2.66666V9.33332C1.66634 9.67521 1.9237 9.95699 2.25526 9.9955L2.33301 9.99999H8.33301C8.6749 9.99999 8.95668 9.74263 8.99519 9.41107L8.99967 9.33332L8.99967 7.9238ZM10.333 7.44732L12.333 8.13332V3.86599L10.333 4.55199V7.44732Z"
              fill="white"/>
    </svg>
</Box>;
const isString = value => typeof value === "string";
const clearPrice = value => isString(value) ? value.replace(/[^\d.]/g, '') : value;
const formatPrice = (price) => {
    const options = {
        style: 'decimal',  // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };
    if(price && isString(price)){
        if(price.indexOf("$") >= 0){
            const onlyPrice = clearPrice(price);
            const formattedPrice = Number(onlyPrice).toLocaleString('en-US', options);
            return price.replace(onlyPrice, formattedPrice);
        }else{
            const onlyPrice = clearPrice(price);
            const formattedPrice = Number(onlyPrice).toLocaleString('en-US', options);
            return price.replace(onlyPrice, formattedPrice);
        }
    }else if (typeof price === "number"){
        return Number(price).toLocaleString('en-US', options);
    }else{
        return price
    }
}

class GridItem extends PureComponent {
    state = {
        ambassador: null,
        height: null,
    };
    imgRef = createRef();
    renderPrice = (product) => {
        const { sale_price, price } = product;
        const currency_symbol = ConfigurationHelper.getCurrencySymbol();
        if (price === 0 || price == 0.0) return;
        let priceToShow = (
            <Box sx={{ minHeight: "35px" }}>
                <Typography
                    align={"center"}
                    component={"div"}
                    fontSize={"12px"}
                    sx={{ color: "#323232" }}
                    lineHeight={"14px"}
                >
                    {currency_symbol || "$"}
                    {formatPrice(price)}
                </Typography>
            </Box>
        );
        if (!product.map && sale_price && price !== sale_price) {
            priceToShow = (
                <Box sx={{ minHeight: "35px" }}>
                    <Typography
                        align={"center"}
                        component={"div"}
                        fontSize={"12px"}
                        sx={{ color: "#323232" }}
                        lineHeight={"14px"}
                    >
                        {currency_symbol || "$"}
                        {formatPrice(sale_price)}
                    </Typography>
                    <Typography
                        component={"div"}
                        align={"center"}
                        fontSize={"10px"}
                        lineHeight={"14px"}
                        sx={{ color: "#727272" }}
                    >
                        <strike>
                            {currency_symbol || "$"}
                            {formatPrice(price)}
                        </strike>
                    </Typography>
                </Box>
            );
        }
        return (
            <Box display={"flex"} justifyContent={"center"}>
                {priceToShow}
            </Box>
        );
    };
    getHeight = () => {
        return this.imgRef?.current ? this.imgRef?.current?.clientHeight : null;
    };
    getProductsMarkup = () => {
        const products = this.props.asset.products || [];
        return products.map(this.getMarkupFromProduct);
    };

    getAmbassadorData = () => {
        const creator = this.props.asset.creator;
        if (!creator) return null;
        return {
            ...creator,
            thumbnail: creator.thumbnail,
            full_name: creator.full_name,
            first_name: creator.first_name,
            last_name: creator.last_name,
            uri_stem: creator.uri_stem,
        };
    };

    getMarkupFromProduct = (product) => {
        const {product_id, image, title, link} = product;
        // Set cookie on product click
        const handleProductClick = (e) => {
            const assetOwner = this.props.asset?.owner;
            common.setCustomCookie(assetOwner);
        };
        return (
            <SwiperSlide key={product_id}>
                <Link
                    type={"a"}
                    key={product_id}
                    href={link}
                    underline={"none"}
                    target={"_blank"}
                    onClick={handleProductClick}
                >
                    <Box
                        key={product_id}
                        border={"1px solid #cccccc"}
                        borderRadius={"4px"}
                        height={"calc(100% - 2px)"}
                    >
                        <Box
                            paddingTop={"100%"}
                            overflow={"hidden"}
                            position={"relative"}
                            sx={{
                                "& img": {
                                    maxHeight: "100%",
                                    position: "absolute",
                                    top: 0,
                                },
                            }}
                        >
                            <img src={image} alt={title} />
                        </Box>
                        <Box>{this.renderPrice(product)}</Box>
                    </Box>
                </Link>
            </SwiperSlide>
        );
    };

    getAmbassadorUrl = () => {
        const ambassador = this.getAmbassadorData();
        if (ambassador)
            return common.generateAmbassadorUrl(ambassador);
        else return "";
    };

    render() {
        const {
            asset,
            lazyLoadingThumbnails,
            enableAmbassador,
            playing,
            maxDescriptionLines,
            dataTestid,
        } = this.props;

        const ambassador = this.getAmbassadorData();
        const assetUrl = common.generateAssetUrlFrom(asset);
        const showPlayIcon = !common.isPhoto(asset);
        const products = this.getProductsMarkup();
        const ambassadorUrl = this.getAmbassadorUrl();
        const ambassadorAvatar = ambassador?.thumbnail || "";
        const category = asset?.category || "";
        const thumbnailUrl = common.getThumbnail(asset);

        return (
            <Box
                overflow={"hidden"}
                testId={"hub-grid-item"}
                data-testid={dataTestid}
                height={"100%"}
                position={"relative"}
                display={"flex"}
                data-categoryId={category}
                flexDirection={"column"}
                backgroundColor={"#ffffff"}
                justifyContent={"space-between"}
                borderRadius={"12px"}
                border={"1px solid #cccccc"}
                sx={{
                    "& a:hover": {
                        textDecoration: "none",
                    },
                }}
            >
                <Box className={(playing ? "watching" : "")}>
                    <Link href={assetUrl}>
                        <Box
                            ref={this.imgRef}
                            paddingTop={"80.20%"}
                            position={"relative"}
                        >
                            <AssetThumbnail
                               thumbnailUrl={thumbnailUrl}
                                alt={asset.title}
                                lazyLoadingThumbnails={lazyLoadingThumbnails}
                                isPhoto={common.isPhoto(asset)}
                            />
                            {showPlayIcon && <RoundedPlayIcon />}
                        </Box>
                    </Link>
                    <Box
                        m={2}
                        position={"relative"}
                        sx={{
                            "& .swiper-button-next, & .swiper-button-prev": {
                                backgroundColor: "transparent",
                                width: "44px",
                                height: "100%",
                                fontWeight: "bold",
                                "&:after": {
                                    color: "#000000",
                                    fontSize: "22px",
                                    content: '""'
                                },
                                "&.swiper-button-disabled": {
                                    display: "none",
                                },
                            },
                            "& .swiper-slide": {
                                height: "auto",
                                padding: 0,
                            },
                            "& .swiper-button-next": {
                                top: "18px",
                                right: "var(--swiper-navigation-sides-offset, 0)",
                            },
                            "& .swiper-button-prev": {
                                top: "18px",
                                left: "var(--swiper-navigation-sides-offset, 0)",
                            },
                            "& .swiper": {
                                overflow: "hidden",
                            },
                        }}
                    >
                        <Swiper
                            style={{
                                "--swiper-navigation-sides-offset": "0",
                                "--swiper-navigation-top-offset": "18px",
                            }}
                            centeredSlides={true}
                            centeredSlidesBounds={true}
                            modules={[Navigation]}
                            navigation
                            spaceBetween={"8px"}
                            slidesPerView={3.7}
                        >
                            {products}
                        </Swiper>
                    </Box>
                </Box>
                <Box px={2}>
                    <Link color="inherit" underline="none" href={assetUrl}>
                        <Typography
                            data-testId={"hub-content-title"}
                            component={"div"}
                            fontSize={16}
                            fontWeight={"bold"}
                            gutterBottom
                        >
                            <Dotdotdot clamp={1}>{asset.title}</Dotdotdot>
                        </Typography>
                        {maxDescriptionLines > 0 && (
                            <Dotdotdot clamp={maxDescriptionLines}>
                                <Typography
                                    component={"div"}
                                    fontSize={14}
                                    lineHeight={"21px"}
                                >
                                    {asset.description}
                                </Typography>
                            </Dotdotdot>
                        )}
                    </Link>
                    <Box
                        display={"flex"}
                        pb={2}
                        alignItems={"center"}
                        flexWrap={"nowrap"}
                        pt={2}
                    >
                        <Box flexGrow={1}>
                            {enableAmbassador &&
                            ambassador &&
                            ambassador.first_name ? (
                                <Link
                                    testId={"hub-grid-item-creator"}
                                    href={ambassadorUrl}
                                    color={"inherit"}
                                    underline={"none"}
                                >
                                    <Box
                                        display={"flex"}
                                        alignItems={"center"}
                                        sx={{
                                            color: "#727272",
                                            "&:hover": {
                                                textDecoration: "underline",
                                            },
                                        }}
                                    >
                                        <Avatar
                                            src={ambassadorAvatar}
                                            sx={{
                                                width: "48px",
                                                height: "48px",
                                                marginRight: "8px",
                                            }}
                                            alt={
                                                ambassador &&
                                                ambassador.full_name
                                                    ? ambassador.full_name
                                                    : ""
                                            }
                                        />
                                        <Typography
                                            data-testId={"hub-creator-name"}
                                            data-lastName={
                                                ambassador.last_name || ""
                                            }
                                            component={"div"}
                                            fontSize={12}
                                            color={"#727272"}
                                            fontWeight={"bold"}
                                        >
                                            <Dotdotdot clamp={1}>
                                                {ambassador.full_name ?? ""}
                                            </Dotdotdot>
                                        </Typography>
                                    </Box>
                                </Link>
                            ) : (!enableAmbassador || ambassador) === false ? (
                                ""
                            ) : (
                                <Box
                                    display={"flex"}
                                    alignItems={"center"}
                                    flexWrap={"nowrap"}
                                >
                                    <Skeleton
                                        variant={"circular"}
                                        height={"48px"}
                                        width={"48px"}
                                        sx={{ marginRight: "5px" }}
                                    />
                                    <Skeleton
                                        height={"48px"}
                                        width={"calc(100% - 48px)"}
                                        sx={{ marginRight: "5px" }}
                                    />
                                </Box>
                            )}
                        </Box>
                        <Box>
                            <Link
                                testId={"hub-grid-item-content"}
                                href={assetUrl}
                            >
                                <Button
                                    variant={"outlined"}
                                    sx={{
                                        padding: {
                                            sm: "12px 12px",
                                            lg: "12px 24px",
                                        },
                                        borderColor: "#000000",
                                        color: "#000000",
                                        fontWeight: "bold",
                                        borderRadius: 0,
                                        fontSize: "12px",
                                        "&:hover": {
                                            backgroundColor: "#ebebeb",
                                            borderColor: "#000000",
                                            color: "#000000",
                                        },
                                    }}
                                >
                                    <Typography
                                        sx={{ textWrap: "nowrap" }}
                                        component={"span"}
                                        fontSize={"12px"}
                                    >
                                        SHOP ALL
                                    </Typography>
                                </Button>
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }
}

GridItem.defaultProps = {
    redirect: true,
    enableAmbassador: ConfigurationHelper.isAmbassadorProgramEnabled(),
    carouselItem: false,
    lazyLoadingThumbnails: true,
    maxDescriptionLines: 4
};

export default GridItem;
